import { render, staticRenderFns } from "./ObrasAssociadas.vue?vue&type=template&id=a28fbb38"
import script from "./ObrasAssociadas.vue?vue&type=script&lang=js"
export * from "./ObrasAssociadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports